import React, { useState } from 'react';
import AsyncSelect from 'react-select/async';

import { StyleWrapper } from './style';

import { STORAGE_IMAGE_URL } from '../../../constants/storage.js';

const ProductImg = `${STORAGE_IMAGE_URL}/newImages/nestle.svg`;

const LazyLoadingSelect = ({
  className,
  placeholder,
  isClearable,
  isSearchable,
  options,
  loadMoreData,
  loading,
  onChange,
  value,
  handleSearch
}) => {

  const [searchText, setSearchText] = useState("");

  const CustomOption = (props) => {
    const { data, innerRef, innerProps } = props;
    const { image, label, identifier1, identifier2 } = data || {};

    return (
      <div className='card-item-wrapper' ref={innerRef} {...innerProps}>
        <img src={image || ProductImg} alt={label} />
        <div className='card-item-content'>
          <p>{label}</p>
          <div className='card-item-details'>
            {identifier1 && <p>{identifier1}</p>}
            {identifier2 && <p>{identifier2}</p>}
          </div>
        </div>
      </div>
    );
  };

  const CustomSingleValue = (props) => {
    const { image, label, identifier1, identifier2 } = props?.data || {};

    return (
      <div className='card-item-wrapper value-ref-wrapper'>
        <img src={image || ProductImg} alt={label} />
        <div className='card-item-content'>
          <p>{label}</p>
          <div className='card-item-details'>
            {identifier1 && <p>{identifier1}</p>}
            {identifier2 && <p>{identifier2}</p>}
          </div>
        </div>
      </div>
    );
  };

  return (
    <StyleWrapper>
      <AsyncSelect
        defaultOptions={options}
        loadOptions={handleSearch}
        placeholder={placeholder}
        inputValue={searchText}
        onInputChange={(e, { action, prevInputValue }) => {
          if (action === 'input-change') {
            if (e === '' && (prevInputValue === searchText)) handleSearch(e);
            setSearchText(e);
          }
          else if (action === 'set-value') setSearchText(e);
        }}
        isClearable={isClearable}
        isSearchable={isSearchable}
        onMenuScrollToBottom={loadMoreData}
        isLoading={loading}
        value={value}
        onChange={onChange}
        components={{
          Option: CustomOption,
          SingleValue: CustomSingleValue,
        }}
        className={`sku-dropdown-opulent ${className}`}
      />
    </StyleWrapper>
  );
};

export default LazyLoadingSelect;
